// Zone shrink/hold machinery is dormant in the brawler (zoneActive() is false for the only
// shipped mode, 'horde') — same "kept dormant, never resurrected" treatment as BR/Squad. `zone`
// itself still gets read every frame by updatePickups()/supply drops for a spawn-radius center,
// so its static init values must match the new flat-pit geometry even though shrink never runs.
const zone = { cx:ARENA_W/2, cy:ARENA_H/2, r:Math.max(ARENA_W,ARENA_H)*0.6, fromCx:0,fromCy:0,fromR:0,toCx:0,toCy:0,toR:0,
  phase:0, state:'hold', t:0, dur:0, dmg:1.5 };
const PHASES = [
  { hold:40, shrink:14, r:ARENA_W*0.40, dmg:2 },
  { hold:30, shrink:12, r:ARENA_W*0.26, dmg:3 },
  { hold:24, shrink:11, r:ARENA_W*0.15, dmg:5 },
  { hold:20, shrink:10, r:ARENA_W*0.08, dmg:7 },
  { hold:16, shrink:9,  r:ARENA_W*0.03, dmg:10 },
  { hold:14, shrink:8,  r:0,          dmg:16 },
];
function syncZoneToWorld3D(){
  const w3d = window.World3D;
  if (!w3d?.ready || typeof w3d.setZone !== 'function') return;
  if (!zoneActive()) { w3d.setZone(0, 0, 0); return; }
  w3d.setZone(zone.cx, zone.cy, Math.max(0, zone.r));
}
function zoneReset(){
  zone.cx=ARENA_W/2; zone.cy=ARENA_H/2; zone.r=Math.max(ARENA_W,ARENA_H)*0.6;
  zone.phase=0; zone.state='hold'; zone.t=0; zone.dur=PHASES[0].hold; zone.dmg=PHASES[0].dmg;
  syncZoneToWorld3D();
}
function zoneUpdate(dt){
  zone.t += dt;
  if(zone.state==='hold'){
    if(zone.t>=zone.dur){
      const ph=PHASES[zone.phase], maxOff=Math.max(0,zone.r-ph.r);
      const a=rand(0,TAU), off=Math.sqrt(Math.random())*maxOff;
      zone.fromCx=zone.cx; zone.fromCy=zone.cy; zone.fromR=zone.r;
      zone.toCx=clamp(zone.cx+Math.cos(a)*off, ph.r, ARENA_W-ph.r);
      zone.toCy=clamp(zone.cy+Math.sin(a)*off, ph.r, ARENA_H-ph.r);
      zone.toR=ph.r; zone.state='shrink'; zone.t=0; zone.dur=ph.shrink; zone.dmg=ph.dmg;
      zoneWarn=2.8; sfx('warn');
    }
  } else if(zone.state==='shrink'){
    const k=clamp(zone.t/zone.dur,0,1), e=k*k*(3-2*k);
    zone.cx=lerp(zone.fromCx,zone.toCx,e); zone.cy=lerp(zone.fromCy,zone.toCy,e); zone.r=lerp(zone.fromR,zone.toR,e);
    if(zone.t>=zone.dur){ zone.cx=zone.toCx; zone.cy=zone.toCy; zone.r=zone.toR;
      zone.phase++; zone.t=0;
      if(zone.phase>=PHASES.length){ zone.state='done'; zone.dur=1e9; }
      else { zone.state='hold'; zone.dur=PHASES[zone.phase].hold; } }
  }
  syncZoneToWorld3D();
}
function outsideZone(e){ return Math.hypot(e.x-zone.cx, e.y-zone.cy) > zone.r; }
function zoneActive(){ return gameMode!=='horde'; }
function safeText(){
  if(zone.state==='done') return 'FINAL';
  if(zone.state==='shrink') return 'closing';
  return Math.ceil(zone.dur - zone.t) + 's';
}

// ============================================================
//  Entities
// ============================================================
